import Vue from "vue";
import App from "./App.vue";
import "leaflet/dist/leaflet.css";
import * as L from "leaflet";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import router from "./router";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount("#app");
